<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <UserView :editing="true" :inputs="fields"/>
  </div>
</template>

<script>
  import UserView from './UserView';
  import fields from './usersEditingFields.js';

  export default {
    name: 'UserEditing',
    components: {
      UserView
    },
    data () {
      return {
        fields: fields
      }
    },
  }
</script>